import moment from "moment";
import React from "react";
import { Card, DateSelectButton, Typography } from "../components";
import DateRangePicker from "../components/Date/DateRangePicker";
import DateSelect from "../components/Date/DateSelectInput";
import Section from "../components/Section";
import { Calendar } from "@phosphor-icons/react";

const DateRangeSection = () => {
	const [state, setState] = React.useState<any>({
		date1: { startDate: moment().subtract(1, "day").toDate(), endDate: null },
		date3: { startDate: moment("2024-08-13"), endDate: moment("2024-08-29") }
	});
	const handleDateChange = (startDate: string, endDate: string, name: string) => {
		console.log("Selected Start Date:", startDate);
		console.log("Selected End Date:", endDate);
		console.log("state", state);
		setState({ ...state, [name]: { startDate, endDate } });
	};
	const handleChange = (e: any) => {
		const key = e.target.name;
		const value = e.target.value;
		console.log("value", value);
		setState({ ...state, [key]: value });
	};

	return (
		<Section title={"# Date Selection calender"}>
			<Typography type="text" size="lg" color="placeholder">
				DateSelect
			</Typography>
			<div className="d-flex gap2 justify-content-center">
				<DateSelect
					id={"date_select"}
					value={state.date_select}
					onChange={(event: any) => handleChange(event)}
					className={""}
					required={true}
					formSubmitted={false}
					name={"date_select"}
					label={"Select Date"}
				/>
				<DateSelect
					id={"date_select"}
					value={state.date_select}
					onChange={(event: any) => handleChange(event)}
					className={""}
					required={true}
					formSubmitted={false}
					name={"date_select"}
					label={"Without Footer"}
					disableFooter={true}
					disableHeader={true}
				/>
				<div className="d-flex align-items-center">
					<DateSelectButton target={<Calendar size={30} className={`icon-color`} />} handleSubmit={() => {}} value={""} />
				</div>
			</div>

			<Typography type="text" size="lg" color="placeholder">
				Date Select Calender
			</Typography>
			<div className="d-flex gap2">
				<Card size={"sm"}>
					<DateRangePicker
						onDateChange={(start, end) => handleDateChange(start, end, "date1")}
						format="YYYY-MM-DD"
						isRangePicker={false}
						value={state.date1}
					/>
				</Card>
				<Card size={"xs"}>
					<DateRangePicker
						onDateChange={(start, end) => handleDateChange(start, end, "date4")}
						format="YYYY-MM-DD"
						isRangePicker={false}
						value={state.date4}
						size="md"
					/>
				</Card>
				<Card size={"xs"}>
					<DateRangePicker
						onDateChange={(start, end) => handleDateChange(start, end, "date5")}
						format="YYYY-MM-DD"
						isRangePicker={false}
						value={state.date5}
						size="sm"
					/>
				</Card>
			</div>
			<Typography type="text" size="lg" color="placeholder">
				Date Range Select in two Calenders
			</Typography>
			<div className="d-flex">
				<Card size={"md"}>
					<DateRangePicker
						onDateChange={(start, end) => handleDateChange(start, end, "date2")}
						format="YYYY-MM-DD"
						isDoubleCalender={true}
						isRangePicker={true}
						value={state.date2}
					/>
				</Card>
			</div>
			<Typography type="text" size="lg" color="placeholder">
				Date Range Select in single Calender
			</Typography>
			<div className="d-flex">
				<Card size={"md"}>
					<DateRangePicker
						onDateChange={(start, end) => handleDateChange(start, end, "date3")}
						format="YYYY-MM-DD"
						isDoubleCalender={false}
						isRangePicker={true}
						value={state.date3}
						defaultMonth={moment().subtract(1, "months")}
					/>
				</Card>
			</div>
		</Section>
	);
};

export default DateRangeSection;
